export const defaultCameraSettings = {
    position: {
        x: 0,
        y: 16,
        z: 29
    },
    distance: [30, 50],
    polarAngle: [0.785, 1.57],
    target: {
        x: 0,
        y: 7,
        z: 0
    }
};
